var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slider',{attrs:{"max":_vm.params.max,"min":_vm.params.min,"step":_vm.params.step,"thumb-label":"always"},on:{"change":_vm.update},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }